module.exports = __webpack_public_path__ + "static/media/we-supply.8937c9f4.png";